import { Layout, Menu } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/logo-white.png";
import { sidebarItems } from "../../navigation/sidebar.config";
import "./Sidebar.css";

const { Sider } = Layout;

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Sider
      width={214}
      style={{
        height: "100vh",
        position: "sticky",
        top: 0,
        background:
          "linear-gradient(180deg,#00C183 0%, #14B07E 61.54%, #C1C89E 123.07%)",
        paddingTop: 10,
      }}
    >
      {/* Logo */}
      <div
        style={{
          // height: 80,
          margin: "10px 16px 20px 16px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <img
          src={logo}
          alt="logo"
          style={{
            width: "120px",
            height: "auto",
            objectFit: "contain",
          }}
        />
      </div>

      {/* Menu */}
      <Menu
        mode="inline"
        selectedKeys={[location.pathname]}
        items={sidebarItems}
        onClick={({ key }) => navigate(key)}
        rootClassName="custom-sidebar-menu"
        style={{
          background: "transparent",
          borderRight: "none",
          padding: "0 8px",
        }}
        theme="dark"
      />
    </Sider>
  );
}